
const router = [
  {
    name: 'set',
    path: '/set',
    meta: {
      title: '站点设置',
      icon: 'shezhi'
    }
  },
  {
    name: 'SetConfig',
    path: '/set/config',
    component: () => import('/@/views/set/Config.vue'),
    meta: { title: '基本设置' }
  },
  {
    name: 'setUserInfo',
    path: '/set/userInfo',
    component: () => import('/@/views/set/UserInfo.vue'),
    meta: { title: '我的账号' }
  },
  {
    name: 'setDomain',
    path: '/set/domain',
    component: () => import('/@/views/set/Domain.vue'),
    meta: { title: '绑定域名' }
  },
  {
    name: 'setOss',
    path: '/set/oss',
    component: () => import('/@/views/set/Oss.vue'),
    meta: { title: '附件设置' }
  }
]
export default router
